module.exports = __webpack_public_path__ + "static/media/checkExample1.f5a199aa.png";